import { createContext, FC, PropsWithChildren, useCallback, useContext, useState } from 'react';

type MenuContextType = {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
};

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const stored = localStorage.getItem('menuCollapsed');
    return stored === 'true';
  });

  const toggleCollapsed = useCallback(() => {
    setIsCollapsed(prev => {
      const newValue = !prev;
      localStorage.setItem('menuCollapsed', String(newValue));
      return newValue;
    });
  }, []);

  const setCollapsed = useCallback((collapsed: boolean) => {
    setIsCollapsed(collapsed);
    localStorage.setItem('menuCollapsed', String(collapsed));
  }, []);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <MenuContext.Provider value={{ isCollapsed, toggleCollapsed, setCollapsed }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenuCollapsed = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenuCollapsed must be used within a MenuProvider');
  }
  return context;
};
